export default function infrastructureOptionsDirective() {
  return {
    template: require('./infrastructure-options.html'),
    scope: {
      customerId: '<',
      department: '=',
      process: '=',
      function: '=',
      infrastructureOptions: '=',
      isEdit: '<',
    },
    controller: 'InfrastructureOptionsController',
    controllerAs: 'infrastructureOptionsVM',
    bindToController: true,
    replace: true,
  };
}
